export const SpeakerVoiceNames = [
  'Ada MS',
  'Ava MS',
  'Christel MS',
  'Josef Aarskov',
  'Uffe Danielsen',
  'Marta KL',
  'Jeppe MS',
  'Christoph MS',
  'Killian MS',
  'Ralf MS',
  'Mattias MS',
  'Sofie MS',
  'Hillevi MS',
  'Pernille MS',
  'Iselin MS',
] as const;
